import React, { useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

import Layout from './components/Layout';
import Login from './auth/LogIn';
import Users from './pages/settings/Users';
import NotFoundPage from './pages/NotFoundPage';
import Dashboard from './pages/Dashboard';
import Branch from './pages/settings/Branch';
import Supplier from './pages/units/Supplier';
import Unit from './pages/units/Unit';

import Room from './pages/room-settings/Room';
import Booking from './pages/reservation/Booking';
import CheckIn from './pages/reservation/CheckIn';
import CheckOut from './pages/reservation/CheckOut';
import RoomStatus from './pages/reservation/RoomStatus';
import Guest from './pages/customer/Guest';
import GuestHouse from './pages/guest-house/GuestHouse';
import HiringVenu from './pages/guest-house/HiringVenu';
import Sauna from './pages/guest-house/Sauna';
import Gym from './pages/guest-house/Gym';
import HiringPlace from './pages/event-management/HiringPlace';
import HiringChair from './pages/event-management/HiringChair';
import Decorrotion from './pages/event-management/Decorrotion';
import Tent from './pages/event-management/Tent';
import AddressSystem from './pages/event-management/AddressSystem';
import Position from './pages/hr/employee/Position';
import Department from './pages/hr/department/Department';
import Employee from './pages/hr/employee/Employee';
import Salary from './pages/hr/employee/Salary';
import CustomerType from './pages/customer/CustomerType';
import FoodCategory from './pages/restaurant/food/FoodCategory';
import Food from './pages/restaurant/food/Food';
import Pos from './pages/restaurant/pos/Pos';
import OrderList from './pages/restaurant/pos/OrderList';
import Stock from './pages/club/stock/Stock';
import Counter from './pages/club/common/Counter';
import ClubInventory from './pages/club/stock/ClubInventory';
import StockReport from './pages/club/reports/StockReport';
import ClubInventoryReport from './pages/club/reports/ClubInventoryReport';
import StockAdjustment from './pages/club/stock/StockAdjustment';
import ClubOrderList from './pages/club/pos/ClubOrderList';
import ClubPos from './pages/club/pos/ClubPos';
import ClubDashboard from './pages/club/common/ClubDashboard';
import DayClossing from './pages/club/common/DayClossing';

// bar
import BarStock from './pages/bar/stock/Stock';
import BarInventory from './pages/bar/stock/BarInventory';
import BarStockReport from './pages/bar/reports/StockReport';
import BarInventoryReport from './pages/bar/reports/BarInventoryReport';
import BarStockAdjustment from './pages/bar/stock/StockAdjustment';
import BarOrderList from './pages/bar/pos/BarOrderList';
import BarPos from './pages/bar/pos/BarPos';
import BarDashboard from './pages/bar/common/BarDashboard';
import DayClosingReport from './pages/club/reports/DayClosingReport';
import BarDayClossing from './pages/bar/common/BarDayClossing';
import BarDayClosingReport from './pages/bar/reports/BarDayClossingReport';
import Ingredient from './pages/restaurant/ingredient/Ingredient';
import IngredientInventory from './pages/restaurant/ingredient/IngredientInventory';
import Adjustment from './pages/restaurant/ingredient/Adjustment';
import InventoryReport from './pages/restaurant/report/InventoryReport';
import IngredientReport from './pages/restaurant/report/IngredientReport';
import OrdersReport from './pages/restaurant/report/OrdersReport';
import ClubOrdersReport from './pages/club/reports/ClubOrdersReport';
import BarOrdersReport from './pages/bar/reports/BarOrdersReport';
import BookingReport from './pages/reservation/BookingReport';
import RestaurantDashboard from './pages/restaurant/common/RestaurantDashboard';
import FacilityTypes from './pages/room-settings/FacilityTypes';
import RestaurantStock from './pages/restaurant/stock/RestaurantStock';
import RestaurantReport from './pages/restaurant/report/RestaurantReport';
import RestaurantStockInventory from './pages/restaurant/stock/RestaurantStockInventory';

const theme = createTheme ({
	palette: {
		primary: {
			main: '#1976d2',
			light: '#222831',
		},
		secondary: {
		    main: '#2e7d32',
			light: '#FFFFFF',
		},
		success: {
            light: '#4caf50',
            main: '#2e7d32',
            contrastText: '#fff',
		},
		info: {
            light: '#2196f3',
            main: '#1976d2',
            contrastText: '#fff',
		},

		background: {
            default: '#f5f5f5',
            paper: '#fff'
		},
	},
});
function App() {

return (
	<SnackbarProvider
	maxSnack={3}
	anchorOrigin={{
		vertical: 'top',
		horizontal: 'right',
	}}>
		<ThemeProvider theme={theme}>
		<CssBaseline />
		<Router>
			<Routes>
				<Route path="/" element={<Login/>} />
			<Route element={<Layout />}>
				<Route path="/dashboard" element={<Dashboard />} />

				{/* event-management   */}
				<Route path="/event-management/venue" element={<HiringPlace />} />
				<Route path="/event-management/chair" element={<HiringChair />} />
				<Route path="/event-management/decoration" element={<Decorrotion />} />
				<Route path="/event-management/tent" element={<Tent />} />
				<Route path="/event-management/address-system" element={<AddressSystem />} />


				{/* restaurant   */}
				<Route path="/restaurant/pos/pos" element={<Pos />} />
				<Route path="/restaurant/common/dashboard" element={<RestaurantDashboard />} />
				<Route path="/restaurant/pos/order" element={<OrderList />} />
				<Route path="/restaurant/food/category" element={<FoodCategory />} />
				<Route path="/restaurant/food/food" element={<Food />} />
				<Route path="/restaurant/ingredient/ingredient" element={<Ingredient />} />
				<Route path="/restaurant/ingredient/inventory" element={<IngredientInventory />} />
				<Route path="/restaurant/ingredient/adjustment" element={<Adjustment />} />
				<Route path="/restaurant/report/inventory" element={<InventoryReport />} />
				<Route path="/restaurant/report/ingredient" element={<IngredientReport />} />
				<Route path="/restaurant/report/order" element={<OrdersReport />} />
				<Route path="/restaurant/stock" element={<RestaurantStock />} />
				<Route path="/restaurant/inventory" element={<RestaurantStockInventory />} />
				<Route path="/restaurant/report/stock" element={<RestaurantReport />} />
				<Route path="/restaurant/report/stock/inventory" element={<RestaurantReport />} />




				{/* hr-employee   */}
				<Route path="/hr-employee/position" element={<Position />} />
				<Route path="/hr-employee/employee" element={<Employee />} />
				<Route path="/hr-employee/salary" element={<Salary />} />

				{/* hr-employee   */}
				<Route path="/hr-department/department" element={<Department />} />


				{/* Customer */}
				<Route path="/customer/guest" element={<Guest />} />
				<Route path="/customer/type" element={<CustomerType />} />
				{/* club   */}
				<Route path="/club/common/dashboard" element={<ClubDashboard />} />
				<Route path="/club/common/day-clossing" element={<DayClossing />} />
				<Route path="/club/common/counter" element={<Counter />} />

				<Route path="/club/stock/stock" element={<Stock />} />
				<Route path="/club/stock/inventory" element={<ClubInventory />} />
				<Route path="/club/stock/adjustment" element={<StockAdjustment />} />
				<Route path="/club/pos/pos" element={<ClubPos />} />
				<Route path="/club/pos/order" element={<ClubOrderList />} />
				<Route path="/club/report/stock" element={<StockReport />} />
				<Route path="/club/report/day-clossing" element={<DayClosingReport />} />
				<Route path="/club/report/inventory" element={<ClubInventoryReport />} />
				<Route path="/club/report/order" element={<ClubOrdersReport />} />


				{/* bar   */}
				<Route path="/bar/common/dashboard" element={<BarDashboard />} />
				<Route path="/bar/common/day-clossing" element={<BarDayClossing />} />
				<Route path="/bar/stock/stock" element={<BarStock />} />
				<Route path="/bar/stock/adjustment" element={<BarStockAdjustment />} />
				<Route path="/bar/pos/pos" element={<BarPos />} />
				<Route path="/bar/pos/order" element={<BarOrderList />} />
				<Route path="/bar/stock/inventory" element={<BarInventory />} />
				<Route path="/bar/report/stock" element={<BarStockReport />} />
				<Route path="/bar/report/inventory" element={<BarInventoryReport />} />
				<Route path="/bar/report/day-clossing" element={<BarDayClosingReport />} />
				<Route path="/bar/report/order" element={<BarOrdersReport />} />


				{/* Unit */}
				<Route path="/units/suppliers" element={<Supplier />} />
				<Route path="/units/units" element={<Unit />} />


				{/* Room Settings */}
				<Route path="/room-settings/type" element={<FacilityTypes />} />
				<Route path="/room-settings/room" element={<Room />} />


				{/* Reservation */}
				<Route path="/reservation/booking" element={<Booking />} />
				<Route path="/reservation/check-in" element={<CheckIn />} />
				<Route path="/reservation/check-out" element={<CheckOut />} />
				<Route path="/reservation/report" element={<BookingReport />} />
				<Route path="/reservation/room-status" element={<RoomStatus />} />

				{/* Guest House Booking  */}
				<Route path="/guest-house/guest-house" element={<GuestHouse />} />
				<Route path="/guest-house/venue-hiring" element={<HiringVenu />} />
				<Route path="/guest-house/sauna" element={<Sauna />} />
				<Route path="/guest-house/gym" element={<Gym />} />

				{/* Settings   */}
				<Route path="/settings/users" element={<Users />} />
				<Route path="/settings/branch" element={<Branch />} />

				{/* 404 within layout for authenticated users */}
				<Route path="*" element={<NotFoundPage />} />
			</Route>
			{/* 404 for non-authenticated routes (if layout not shown) */}
            <Route path="*" element={<NotFoundPage />} />
			</Routes>
		</Router>
		</ThemeProvider>
	</SnackbarProvider>
);
}

export default App;

